<template>
    <div class="w-full flex justify-between items-center py-2 block border border-white" :class="{'bg-gray-100 hover:bg-gray-100 hover:border-gray-400 border-gray-400' : edit, 'hover:border-blue-400 hover:bg-blue-50' : ! edit, 'pl-8' : type === 'child' }">
        <div class="flex items-center">
            <div class="item-number cursor-pointer py-1 px-2">
                <span v-if="type === 'child'">{{ parent.order+1 }}.</span>
                <span>{{ note.order+1 }}</span>
            </div>
            <div v-if="! edit">{{ note.title }}</div>
            <input v-if="edit" v-model="updateNote.title"   class="p-2 text-sm" />
            <label v-if="edit && ! note.link_to_file" for="noteFile" class="text-xs px-4 cursor-pointer text-blue-600 hover:text-blue-800 flex items-center">
                <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                <span>Add File</span>
                <input id="noteFile" type="file" ref="noteFile" class="hidden" @change="uploadFile()" />
            </label>
            <a href="#" @click.prevent="note.link_to_file = null" v-if="edit && note.link_to_file" for="noteFile" class="text-xs px-4 cursor-pointer text-red-400 hover:text-red-600 flex items-center">
                <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                <span>Remove File</span>
            </a>
            <a v-if="note.link_to_file && ! edit" :href="`/storage/${note.link_to_file}`" target="_blank" class="px-4 text-xs text-blue-600 hover:text-blue-800 flex items-center">
                <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                <span>View File</span>
            </a>
        </div>
        <div v-if="! edit" class="flex items-center note-item-actions">
            <div v-if="! note.children.length && type === 'parent'"><svg @click="$emit('make-child', note, index)" class="w-5 h-5 text-gray-500 cursor-pointer mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></div>
            <div v-if="type === 'child'"><svg @click="$emit('make-parent', note, index)" class="w-5 h-5 text-gray-500 cursor-pointer mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"></path></svg></div>
            <div><svg @click="edit = true" class="w-5 h-5 text-gray-500 cursor-pointer mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg></div>
        </div>
        <div v-if="edit" class="flex items-center">
            <div v-if="! deleteConfirm" class="flex items-center">
                <button @click="saveNote()" type="button" class="mr-2 flex items-center justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 text-xs">Save</button>
                <button @click="deleteConfirm = true" type="button" class="mr-4 flex items-center justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-400 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 text-xs">Delete</button>
                <div><svg @click="edit = false" class="w-5 h-5 text-gray-500 cursor-pointer mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></div>
            </div>
            <div v-if="deleteConfirm" class="flex items-center">
                <button @click="deleteNote()" type="button" class="mr-2 flex items-center justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-400 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 text-xs">Confirm Delete</button>
                <button @click="deleteConfirm = false" type="button" class="mr-4 flex items-center justify-center py-1 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-gray-600 text-xs">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        note: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        parent: {
            type: Object,
        }
    },
    data() {
        return {
            edit: false,
            updateNote: this.note,
            deleteConfirm: false,
        }
    },
    methods: {
        saveNote() {
            this.$emit('updateNote')
            this.edit = false
        },
        deleteNote() {
            axios.delete(route('settings.board-note-item.destroy', this.note.id)).then(
                () => this.$inertia.get(route('settings.board-notes.show', this.note.board_note_id))
            )
            this.edit = false
        },
        uploadFile() {
            let formData = new FormData()
            formData.append('file', this.$refs.noteFile.files[0])
            axios.post( route('settings.board-note-item-file'), formData).then(
                response => this.updateNote.link_to_file = response.data
            )
        }
    }
}
</script>


<style scoped>
.note-item-actions {
    display: none;
}

.note-item:hover .note-item-actions {
    display: flex;
}

.child-note-item:hover .note-item-actions {
    display: flex;
}
</style>
